import { PlatformEmailForm } from "./PlatformEmailForm";
import { TrustedByCompanies } from "./TrustedByCompanies";

export const HumanloopHero = () => {
  return (
    <div className="container-xl">
      <div className="selection:rounded selection:border selection:bg-blue-200 lg:px-48 xl:px-120">
        <div className="col-span-full">
          <h1 className="mt-40 font-display text-[40px] leading-[44px] md:text-[60px] md:leading-[60px] lg:text-[72px] lg:leading-[72px] xl:text-[80px] xl:leading-[80px]">
            Rapidly build <br className="block homeXs:hidden" /> NLP models
            <br className="hidden sm:block" /> that continuously improve
          </h1>
          <p className="mt-40 mb-32 max-w-sm text-14-22 text-gray-800 lg:max-w-lg lg:text-18-28">
            Join thousands of developers using Humanloop&apos;s tools to build
            intelligence into their apps and workflows
          </p>
          <div className="mb-[92px] flex flex-wrap gap-x-48 gap-y-32">
            <div className="min-w-[240px] max-w-lg grow">
              <PlatformEmailForm />
            </div>
            <TrustedByCompanies />
          </div>
        </div>
      </div>
    </div>
  );
};
